// extracted by mini-css-extract-plugin
module.exports = {"mortgage":"MortgageCard_mortgage__52rwG"};